// @core/api/endpoints/task/reschedule_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RescheduleTaskRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Reschedule task
 * Moves the scheduled work block for a task to a new time. Updates the assignee's calendar accordingly. Validates that the new time slot is available.
 */
export async function RescheduleTask(
  task_id: string,
  data: RescheduleTaskRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/reschedule`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
